
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire11f4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire11f4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3gJDb", function(module, exports) {

$parcel$export(module.exports, "identity", () => $aeb32aab3f19cbf9$export$f0954fd7d5368655);
$parcel$export(module.exports, "wrap", () => $aeb32aab3f19cbf9$export$4997ffc0176396a6);
$parcel$export(module.exports, "void_promise", () => $aeb32aab3f19cbf9$export$7a90e52a324e89a2);
$parcel$export(module.exports, "reduce_sum", () => $aeb32aab3f19cbf9$export$def0c1bcdeb703b8);
$parcel$export(module.exports, "as_tuples", () => $aeb32aab3f19cbf9$export$3549bf827609b016);
$parcel$export(module.exports, "text", () => $aeb32aab3f19cbf9$export$6f093cfa640b7166);
$parcel$export(module.exports, "disable_loading_indicator", () => $aeb32aab3f19cbf9$export$de25300b56fb6cec);
$parcel$export(module.exports, "enable_loading_indicator", () => $aeb32aab3f19cbf9$export$581ce0c8c9a55fd1);
$parcel$export(module.exports, "debounce", () => $aeb32aab3f19cbf9$export$61fc7d43ac8f84b0);
$parcel$export(module.exports, "pointer_events", () => $aeb32aab3f19cbf9$export$9f4d51799e979466);
/**
 * A module containing common type definitions
 * and helper functions.
 */ /**
 * Types that can be cloned using `structuredClone()`.
 *
 * This type excludes excludes Wev/API specific types. Not particular reason for this.
 * It was simply a pain to add them all. Feel free to add them as needed.
 *
 * Refer to [MDN](https://developer.mozilla.org/en-US/docs/Web/API/Web_Workers_API/Structured_clone_algorithm)
 * for a complete overview.
 *
 * |> Beware that this custom Error types are not allowed in `structuredClone()`
 * |> even if the type says it allows any Error type.
 */ const $aeb32aab3f19cbf9$export$f0954fd7d5368655 = (v)=>v;
const $aeb32aab3f19cbf9$export$4997ffc0176396a6 = (v)=>()=>v;
const $aeb32aab3f19cbf9$export$7a90e52a324e89a2 = (cb)=>{
    return cb;
};
const $aeb32aab3f19cbf9$export$def0c1bcdeb703b8 = (acc, v)=>acc + v;
const $aeb32aab3f19cbf9$export$3549bf827609b016 = (obj)=>Object.keys(obj).map((key)=>[
            key,
            obj[key]
        ]);
function $aeb32aab3f19cbf9$export$6f093cfa640b7166(text, node_type) {
    if (node_type) {
        const node = document.createElement(node_type);
        node.innerText = text;
        return node;
    }
    return document.createTextNode(text);
}
const $aeb32aab3f19cbf9$export$de25300b56fb6cec = ()=>{
    const indicator = document.getElementById('loading-indicator');
    indicator.style.display = 'none';
    indicator.classList.remove('natural-pos');
};
const $aeb32aab3f19cbf9$export$581ce0c8c9a55fd1 = (natural_pos = false)=>{
    const indicator = document.getElementById('loading-indicator');
    indicator.style.display = 'block';
    if (natural_pos) indicator.classList.add('natural-pos');
};
const $aeb32aab3f19cbf9$export$61fc7d43ac8f84b0 = (delay, f)=>{
    let timeout;
    let bounces = 0;
    return (e)=>{
        if (timeout != null) {
            clearTimeout(timeout);
            bounces += 1;
        }
        timeout = setTimeout(()=>{
            f(e, bounces);
            bounces = 0;
            timeout = null;
        }, delay);
    };
};
const $aeb32aab3f19cbf9$export$9f4d51799e979466 = (target, handles)=>{
    let active_pointer;
    let click_handle;
    if ('click' in handles) click_handle = handles['click'];
    if ('n_click' in handles) {
        if (click_handle != null) console.warn('incompatible events given in `pointer_events` (click + n_click)');
        click_handle = $aeb32aab3f19cbf9$export$61fc7d43ac8f84b0(200, handles['n_click']);
    }
    const check_hold = 'hold' in handles;
    let hold_timeout;
    let trigger_release = false;
    target.addEventListener('pointerdown', (e)=>{
        if (handles.stop_propagation === true) e.stopPropagation();
        if (e.button !== 0 || active_pointer != null) return;
        active_pointer = e.pointerId;
        if (check_hold) {
            const [length, handle] = handles.hold;
            hold_timeout = setTimeout(()=>{
                // Setting the active_pointer to null cancels the pointerup event
                active_pointer = null;
                hold_timeout = null;
                handle();
                if (handles.hold.length === 3) trigger_release = true;
            }, length);
        }
    });
    target.addEventListener('pointerup', (e)=>{
        if (e.button === 0 && trigger_release) {
            trigger_release = false;
            handles.hold[2]();
        }
        if (e.button !== 0 || e.pointerId !== active_pointer) return;
        if (hold_timeout != null) {
            clearTimeout(hold_timeout);
            hold_timeout = null;
        }
        if (click_handle != null) click_handle(e);
        active_pointer = null;
    });
    target.addEventListener('pointercancel', (e)=>{
        if (e.pointerId === active_pointer) {
            active_pointer = null;
            if (hold_timeout != null) {
                clearTimeout(hold_timeout);
                hold_timeout = null;
            }
        }
    });
};

});

// @ts-ignore
var $966e5d9f8d733f5e$exports = {};
$966e5d9f8d733f5e$exports = JSON.parse('{"0":["Clrs","./songs/CLRS.html"],"1":["Alle dat\'er er glade for porter","./songs/alledatererfladeforporter.html"],"2":["Alle s\xf8m\xe6nd er glade for piger","./songs/allesomaendergladeforpiger.html"],"3":["Bingospilleren","./songs/bingospilleren.html"],"4":["Bright side of life","./songs/brightsideoflife.html"],"5":["Fredagsfranskbr\xf8dsreglsangen","./songs/broedsang.html"],"6":["Bubbibj\xf8rn","./songs/bubbibjorn.html"],"7":["Buster","./songs/busters.html"],"8":["Costa del sol","./songs/costadelsol.html"],"9":["Danskens sande gl\xe6de","./songs/danskenssandeglaede.html"],"10":["Danskens sande gl\xe6de","./songs/danskenssandegl\xe6de.html"],"11":["Dat62(1/2)80 slagsang","./songs/dat62.html"],"12":["Den lille gr\xf8nne fr\xf8","./songs/denlillegroennefroe.html"],"13":["Den r\xf8de tr\xe5d","./songs/denroedetraad.html"],"14":["Der er et \xf8lrigt lang","./songs/dereretoelrigtland.html"],"15":["Der er noget galt i danmark","./songs/derernogetgaltidanmark.html"],"16":["Der kan man c","./songs/derkanmanc.html"],"17":["Der var en skikkelig bondemand...","./songs/dervarenskikkeligbondemand.html"],"18":["Drunken boand","./songs/drunkenboand.html"],"19":["Drunken sailor","./songs/drunkensailor.html"],"20":["Du m\xe5 f\xe5 min c-compiler n\xe5r jeg d\xf8r","./songs/dumaafaaminccompilernaajegdor.html"],"21":["Elskabssang","./songs/elskabssang.html"],"22":["En kort en lang","./songs/enkortenlang.html"],"23":["En mand faldt ned fra f\xf8rste sal","./songs/enmandfaldtnedfrafoerstesal.html"],"24":["En meget nostalgisk vise","./songs/enmegetnostalgiskvise.html"],"25":["En p\xe6dagogisk vise","./songs/enp\xe6dagogiskvise.html"],"26":["Et barn er f\xf8dt i bethlehem","./songs/etbarnerfoedtibethlehem.html"],"27":["Et sidste farvel","./songs/etsidstefarvel.html"],"28":["Fit er frit","./songs/fiterfrit.html"],"29":["Flagsang","./songs/flagsang.html"],"30":["Forureningsvisen","./songs/forureningsvisen.html"],"31":["Fottesangen","./songs/fottesangen.html"],"32":["Fru jensen fra tolne","./songs/frujensenfratolne.html"],"33":["Fytteturssangen","./songs/fytteturssangen.html"],"34":["Gl\xe6delig jul","./songs/glaedeligjul.html"],"35":["Himmelhunden","./songs/himmelhunden.html"],"36":["Hjemmebr\xe6nderiet","./songs/hjemmebraenderiet.html"],"37":["Hvad skal vi kode i nat","./songs/hvadskalvikodeinat.html"],"38":["Hvalborg","./songs/hvalenhvalborg.html"],"39":["Hvem sidder foran sk\xe6rmen","./songs/hvemsidderforanskaermen.html"],"40":["I en lille b\xe5d der gynger","./songs/ienlillebaaddergynder.html"],"41":["Imagine","./songs/imagine.html"],"42":["Introduktionsvise","./songs/introduktionsvise.html"],"43":["Jeg er en n\xf8rd","./songs/jegerennoerd.html"],"44":["Jeg s\xe5 julemanden kysse mor","./songs/jegsaajulemandenkyssemor.html"],"45":["Jingle bell rock","./songs/jinglebellrock.html"],"46":["Joanna","./songs/joanna.html"],"47":["Julemad og drikke---dur for nissen ikke","./songs/julemadogdrikke.html"],"48":["Boand","./songs/krabbeboand.html"],"49":["Til ungdommen","./songs/kringsattavfiender.html"],"50":["Langt fra hjemmet uden \xf8l","./songs/langtfrahjemmetuden\xf8l.html"],"51":["Let it snow","./songs/letitsnow.html"],"52":["Lille prinsesse","./songs/lilleprinsesse.html"],"53":["Livet","./songs/livet.html"],"54":["F-klubbens lucia sang (den franske version)","./songs/luciasangenfredagsfranskbroed.html"],"55":["F-klubbens lucia sang","./songs/luciasangenfredagsikkeonsdag.html"],"56":["En m\xe5lrettet vise","./songs/maalrettedevise.html"],"57":["Masser af cc","./songs/masserafcc.html"],"58":["Ma\xb4matik","./songs/matmatik.html"],"59":["Mcarine","./songs/mcarine.html"],"60":["Meyers vise","./songs/meyersvise.html"],"61":["P\xe5 cassiopeia til foobar","./songs/paacassiopeiatilfoobar.html"],"62":["P\xe5 loftet sidder nissen med sin julegr\xf8d","./songs/paaloftetsiddernissenmedsinjulegrod.html"],"63":["Puff den magiske drage","./songs/puffdenmagiskedrage.html"],"64":["Regnsangen","./songs/regnsangen.html"],"65":["Resultater af f-klubbens afgangspr\xf8ve","./songs/resultateraffklubbensafgangspr\xf8ve.html"],"66":["Sandhans","./songs/sandhans.html"],"67":["Santa claus is coming to town","./songs/santaclausiscomingtotown.html"],"68":["Se venedig og d\xf8","./songs/sevenedigogd\xf8.html"],"69":["Skipper klements morgensang","./songs/skipperklementsmorgensang.html"],"70":["S\xf8ren banjomus","./songs/sorenbenjomus.html"],"71":["Svantes lykkelige dag","./songs/svanteslykkeligedag.html"],"72":["Til julebal i nisseland","./songs/tiljulebalinisseland.html"],"73":["Tine pingvin","./songs/tinepingvin.html"],"74":["Veteranens nostalgiske sang","./songs/veteranensnostalgiskesang.html"],"75":["Vi er ikke humanister","./songs/vierikkehumanister.html"],"76":["Vi har lejrb\xe5l her","./songs/viharlejrbaalher.html"],"77":["Whiskey in the jar","./songs/whiskeyinthejar.html"]}');


function $de319b93e4d94632$var$chunk(a, n) {
    if (n <= 0) throw `Invalid chunk size: ${n}`;
    const r = [];
    const l = a.byteLength;
    for(let i = 0; i < l; i++)r.push(a.slice(i, i + n));
    return r;
}
function $de319b93e4d94632$var$levenshtein_distance(a, b) {
    const n = a.length; // Lenght of array a
    const m = b.length; // Length of array b
    let dc = 0; // The cost to delete
    let ic = 0; // The cost to insert
    let sc = 0; // The cost to substitute
    let d0 = new Int16Array(m + 1); // Distance array row 0
    let d1 = new Int16Array(m + 1); // Distance array row 1
    // No need to calculate distance if one of the arrays are empty
    if (n === 0 || m === 0) return Number.MAX_VALUE;
    // Populate row 0 with the distance the index of charaters in a
    for(let i = 0; i <= n; i++)d0[i] = i;
    for(let i = 0; i < m; i++){
        // First element of row 1 is equivilant to element i + 1 in the initial row 0.
        d1[0] = i + 1;
        for(let j = 0; j < n; j++){
            dc = d0[j + 1] + 1;
            ic = d1[j] + 1;
            sc = a[i] === b[j] ? d0[j] : d0[j] + 1;
            d1[j + 1] = Math.min(dc, ic, sc);
        }
        // Swap current row and previous row
        [d0, d1] = [
            d1,
            d0
        ];
    }
    return d0[n];
}
function $de319b93e4d94632$export$4c5b9c4c038b5c35(s) {
    const array = new Int16Array(s.length);
    for(let i = 0; i < s.length; i++)array[i] = s.charCodeAt(i);
    return array;
}
function $de319b93e4d94632$export$3f85a9b8247b5e89(a, b) {
    const c = $de319b93e4d94632$var$chunk(b, a.length);
    let s = Number.MAX_VALUE;
    for(let j = 0; j < c.length; j++){
        const t = $de319b93e4d94632$var$levenshtein_distance(a, c[j]);
        s = s > t ? t : s;
    }
    return s;
}



var $3gJDb = parcelRequire("3gJDb");
const $f757a9352163b6ca$var$search_element = document.getElementById("search");
const $f757a9352163b6ca$var$links_element = document.getElementById("links");
let $f757a9352163b6ca$var$song_elements = [];
function $f757a9352163b6ca$var$create_song_element(num, key, link) {
    const a = document.createElement("a");
    a.href = link;
    const d = document.createElement("div");
    d.className = "border-inner";
    const p = document.createElement("p");
    p.innerText = num + ". " + key;
    d.appendChild(p);
    a.appendChild(d);
    return {
        element: a,
        search: (0, $de319b93e4d94632$export$4c5b9c4c038b5c35)(key),
        score: 0,
        index: Number(num)
    };
}
$f757a9352163b6ca$var$search_element.addEventListener("input", (0, $3gJDb.debounce)(100, (_)=>{
    const a = $f757a9352163b6ca$var$search_element.value;
    if (a === "") {
        $f757a9352163b6ca$var$links_element.innerHTML = "";
        $f757a9352163b6ca$var$song_elements.sort((a, b)=>a.index - b.index);
    } else {
        let song_num = Number(a);
        if (!Number.isNaN(song_num)) $f757a9352163b6ca$var$song_elements = $f757a9352163b6ca$var$song_elements.sort((a, b)=>Math.abs(song_num - a.index) - Math.abs(song_num - b.index));
        else {
            for (const song of $f757a9352163b6ca$var$song_elements)song.score = (0, $de319b93e4d94632$export$3f85a9b8247b5e89)((0, $de319b93e4d94632$export$4c5b9c4c038b5c35)(a), song.search);
            $f757a9352163b6ca$var$song_elements = $f757a9352163b6ca$var$song_elements.sort((a, b)=>a.score - b.score);
            $f757a9352163b6ca$var$links_element.innerHTML = "";
        }
    }
    for (const song_element of $f757a9352163b6ca$var$song_elements)$f757a9352163b6ca$var$links_element.appendChild(song_element.element);
}));
document.addEventListener("DOMContentLoaded", (_)=>{
    for(const key in 0, (/*@__PURE__*/$parcel$interopDefault($966e5d9f8d733f5e$exports)))$f757a9352163b6ca$var$song_elements.push($f757a9352163b6ca$var$create_song_element(key, (0, (/*@__PURE__*/$parcel$interopDefault($966e5d9f8d733f5e$exports)))[key][0], (0, (/*@__PURE__*/$parcel$interopDefault($966e5d9f8d733f5e$exports)))[key][1]));
    $f757a9352163b6ca$var$links_element.innerHTML = "";
    for (const song_element of $f757a9352163b6ca$var$song_elements)$f757a9352163b6ca$var$links_element.appendChild(song_element.element);
});


//# sourceMappingURL=songbook.0c2fdb40.js.map
